import request from '@/utils/request'

export function getAudits(params) {
  return request({
    url: 'audit',
    method: 'get',
    params
  });
}

export function getAuditById(id) {
  return request({
    url: `audit/${id}`,
    method: 'get'
  });
}

export function getAuditsByModel(auditable_type, auditable_id) {
  return request({
    url: 'audit/by-model',
    method: 'post',
    data: { auditable_type, auditable_id }
  });
}

export function getAuditEvents() {
  return request({
    url: 'audit/filters/events',
    method: 'get'
  });
}

export function getAuditableTypes() {
  return request({
    url: 'audit/filters/types',
    method: 'get'
  });
}

export function getAuditTags() {
  return request({
    url: 'audit/filters/tags',
    method: 'get'
  });
}

export function getAuditStatistics(params) {
  return request({
    url: 'audit/statistics/summary',
    method: 'get',
    params
  });
}

export function exportAudits(data) {
  return request({
    url: 'audit/export',
    method: 'post',
    data
  });
}
